export enum EMedicalCategoryType {
  TREATMENT = 'TREATMENT',
  DEPARTMENT = 'DEPARTMENT',
  VACCINATION = 'VACCINATION',
}
export interface MedicalCategory {
  id: string;
  category: EMedicalCategoryType;
  name: string;
  iconUrl?: string;
}
export class MedicalCategoryModel {
  readonly id: string;
  readonly category: EMedicalCategoryType;
  readonly name: string;
  readonly iconUrl?: string;

  constructor({ _medicalCategory }: { _medicalCategory: MedicalCategory }) {
    this.id = _medicalCategory.id;
    this.category = _medicalCategory.category;
    this.name = _medicalCategory.name;
    this.iconUrl = _medicalCategory.iconUrl;
  }
}
